var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { color, expression, formatters } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { resolveBackgroundColor } from '@philips-internal/oswald-ui-utils';
import TagAPI from './tag-api.js';
import './tag.css';
let Tag = class Tag extends Component {
    render() {
        const { color, formatters } = this.props;
        const { value } = ModelService.formatProps(this.props, ['value'], formatters);
        if (!value || (value && !value.length)) {
            return null;
        }
        return (React.createElement("div", { className: "c-tag", style: resolveBackgroundColor(color), "x-contrast": "bg" },
            React.createElement("span", { className: "c-tag__text" }, MessageService.translate(value))));
    }
};
Tag.propTypes = {
    color: color,
    formatters: formatters,
    value: expression,
};
Tag.defaultProps = {
    color: 'signal-gray-30',
    value: '',
};
Tag = __decorate([
    AwesomeComponent({ api: TagAPI, type: ComponentType.DATA_DISPLAY })
], Tag);
export default Tag;
//# sourceMappingURL=tag.js.map